import { Account } from "@/types/api";

export type Response = {
  account: Account;
};

export enum UserDetailsTab {
  PatientInfo = 0,
  CallPlans = 1,
  Playlists = 2,
  UsageHistory = 3,
  CallSchedules = 4,
}

export const USER_DETAILS_TAB_META: Record<UserDetailsTab, { slug: string; label: string }> = {
  [UserDetailsTab.PatientInfo]: { slug: "patient-info", label: "Patient Info" },
  [UserDetailsTab.CallPlans]: { slug: "call-plans", label: "Call Plans" },
  [UserDetailsTab.Playlists]: { slug: "playlists", label: "Playlists" },
  [UserDetailsTab.UsageHistory]: { slug: "usage-history", label: "Usage History" },
  [UserDetailsTab.CallSchedules]: { slug: "call-schedules", label: "Call Schedules" },
};

export const USER_DETAILS_TAB_ORDER: UserDetailsTab[] = [
  UserDetailsTab.PatientInfo,
  UserDetailsTab.CallPlans,
  UserDetailsTab.Playlists,
  UserDetailsTab.UsageHistory,
  UserDetailsTab.CallSchedules,
];

export const userDetailsTabFromSlug = (slug: string | undefined): UserDetailsTab | undefined => {
  const normalized = slug?.toLowerCase();
  if (!normalized) {
    return;
  }

  return USER_DETAILS_TAB_ORDER.find((tab) => USER_DETAILS_TAB_META[tab].slug === normalized);
};

export const userDetailsTabSlug = (tab: UserDetailsTab): string => USER_DETAILS_TAB_META[tab].slug;

export interface TabPanelProps {
  children?: React.ReactNode;
  index: UserDetailsTab;
  value: UserDetailsTab;
}

export type AccessNotificationInput = {
  accountId: number;
  accessedBy: string;
  source: string;
};
